import React from 'react';
import PropTypes from 'prop-types';

import FirmSection from 'components/FirmSection';
import FormDialog from 'scenes/Dialog/components/FormDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import List from 'scenes/List';
import FirmStrategyEditInvestmentForm from 'scenes/Form/components/FirmStrategyEditInvestmentForm';
import FirmStrategyCreateUpdateFundForm from 'scenes/Form/components/FirmStrategyCreateUpdateFundForm';
import FirmStrategyFundItem from 'scenes/FirmStrategy/components/FirmStrategyFundItem';
import FirmStrategyInvestmentSection from 'scenes/FirmStrategy/components/FirmStrategyInvestmentSection';

import { POPUP_STYLES } from 'constants/popup-styles';

import './styles.css';

const FirmStrategy = props => {
  const {
    firm: { FirmID },
    funds,
    investment,
    isEditMode,
    onAddFundHistory,
    onEditFundHistory,
    onDeleteFundHistory,
    onEditInvestmentStrategy,
    onDeleteInvestmentStrategy,
  } = props;

  const editInvestmentStrategy = () => {
    FormDialog({
      title: 'Edit Investment Strategy',
      modeless: false,
      compact: true,
      popupStyles: { ...POPUP_STYLES.formPopupStyles, maxWidth: '540px' },
      popupInnerStyles: POPUP_STYLES.formInnerStyles,
      popupTitleStyles: POPUP_STYLES.formTitleStyles,
      params: {
        id: FirmID,
        FirmStrategyID: investment ? investment.FirmStrategyID : null,
      },
      form: (actions, params) => (
        <FirmStrategyEditInvestmentForm actions={actions} params={params} />
      ),
    }).then(
      response => onEditInvestmentStrategy(response),
      response => ResponseErrorDialog({ response })
    );
  };

  const editFundraisingHistory = FirmFundHistoryID => {
    FormDialog({
      title: 'Edit Fund',
      modeless: false,
      compact: true,
      popupStyles: { ...POPUP_STYLES.formPopupStyles, maxWidth: '540px' },
      popupInnerStyles: POPUP_STYLES.formInnerStyles,
      popupTitleStyles: POPUP_STYLES.formTitleStyles,
      params: { id: FirmID, FirmFundHistoryID },
      form: (actions, params) => (
        <FirmStrategyCreateUpdateFundForm actions={actions} params={params} />
      ),
    }).then(
      response => onEditFundHistory(response),
      response => ResponseErrorDialog({ response })
    );
  };

  const addFundraisingHistory = () => {
    FormDialog({
      title: 'Add Fund',
      modeless: false,
      compact: true,
      popupStyles: { ...POPUP_STYLES.formPopupStyles, maxWidth: '540px' },
      popupInnerStyles: POPUP_STYLES.formInnerStyles,
      popupTitleStyles: POPUP_STYLES.formTitleStyles,
      params: { id: FirmID },
      form: (actions, params) => (
        <FirmStrategyCreateUpdateFundForm actions={actions} params={params} />
      ),
    }).then(
      response => onAddFundHistory(response),
      response => ResponseErrorDialog({ response })
    );
  };

  return (
    <div className="firm-strategy">
      <FirmStrategyInvestmentSection
        isEditMode={isEditMode}
        data={investment}
        onEditInvestmentStrategy={editInvestmentStrategy}
        onDeleteInvestmentStrategy={onDeleteInvestmentStrategy}
      />

      {isEditMode ? (
        <FirmSection
          title="Fundraising History"
          controls={[{ caption: 'Add', handler: addFundraisingHistory }]}
        >
          <div className="firm-strategy__funds">
            <List
              items={funds}
              listStyles={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}
              itemRender={item => (
                <FirmStrategyFundItem
                  key={item.FirmFundHistoryID}
                  item={item}
                  editMode={isEditMode}
                  onEditClick={editFundraisingHistory}
                  onDeleteClick={onDeleteFundHistory}
                />
              )}
            />
          </div>
        </FirmSection>
      ) : Boolean(funds.length > 0) ? (
        <FirmSection title="Fundraising History">
          <div className="firm-strategy__funds">
            <List
              items={funds}
              listStyles={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}
              itemRender={item => (
                <FirmStrategyFundItem
                  key={item.FirmFundHistoryID}
                  item={item}
                />
              )}
            />
          </div>
        </FirmSection>
      ) : null}
    </div>
  );
};

FirmStrategy.propTypes = {
  firm: PropTypes.shape({
    FirmID: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
  }).isRequired,
  funds: PropTypes.array,
  investment: PropTypes.object,
  isEditMode: PropTypes.bool.isRequired,
  onAddFundHistory: PropTypes.func,
  onEditFundHistory: PropTypes.func,
  onDeleteFundHistory: PropTypes.func,
  onEditInvestmentStrategy: PropTypes.func,
  onDeleteInvestmentStrategy: PropTypes.func,
};

export default FirmStrategy;
